import React, { useEffect, useState } from 'react';
import "./Your_spritual_sec_card.css";
import Yellow_Btn from '../../../common/common_btn/yellow_btn/Yellow_Btn';
import Guest_house_booking_modal from '../../../common/modals/guest-house-booking-modal/Guest_house_booking_modal';
import { useNavigate } from 'react-router-dom';

function Your_spritual_sec_card({ onClick }) {
    const [modalShow, setModalShow] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();

    const images = [
        process.env.PUBLIC_URL + "/assets/images/explore/your-spritual/banner_1.png",
        process.env.PUBLIC_URL + "/assets/images/explore/your-spritual/banner_2.png",
        process.env.PUBLIC_URL + "/assets/images/explore/your-spritual/banner_1.png",
        process.env.PUBLIC_URL + "/assets/images/explore/your-spritual/banner_2.png",
    ];

    // Auto-change every 3 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <>
            <section className='Your_spritual_sec_card' >
                <div className="banner_img_holder">
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt="banner"
                            className={`bannerimg ${index === currentIndex ? "active" : ""}`}
                        />
                    ))}
                </div>

                <div className="content_hodler">
                    <h5>Your Spiritual Stay Awaits</h5>
                    <div className="Reserve_btn">
                        <Yellow_Btn
                            btnText={"Reserve Now!"}
                            onClick={() => navigate("/guest-house")}
                            className='zoom_in_out'
                        />
                    </div>
                </div>
            </section>

            <Guest_house_booking_modal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
}

export default Your_spritual_sec_card;
